import { CSSObject } from '@mantine/core';
import { textVariants } from '@ui/tokens/typography/typography';
import { MantineThemeComponent } from '../../types';

const TooltipDefaultConfig: MantineThemeComponent = {
	defaultProps: {
		arrowSize: 5,
		withArrow: true,
		arrowPosition: 'center',
		color: '#061324',
		position: 'bottom',
		p: '8px',
		offset: 4
	},
	styles: () => ( {
		tooltip: {

			...( textVariants[ 'caption-regular' ] as CSSObject ),
			color: '#fff'
		}
	} )
};

export default TooltipDefaultConfig;
